// Chapter 4 of the detective game: "확산" (see Detective.js).
// Everything the player reads lives here; Detective.js only knows how to play it.

const n = (text) => ({ who: 'narr', text });
const me = (text) => ({ who: 'me', text });
const say = (who, text) => ({ who, text });

export const META = {
  id: 'ch4',
  number: 4,
  hanja: '擴散',
  name: '확산',
  subtitle: '한성물류 화재 연쇄 사건',
  tagline: '흩어진 것들은 한 점에서 왔다.',
  saveKey: 'detective_progress_ch4',
  startLoc: 'hq',
  // The in-game clock runs on clues found, in minutes from the first Monday's midnight.
  clock: {
    start: 840,
    end: 6780,
    days: ['4월 7일', '4월 8일', '4월 9일', '4월 10일', '4월 11일'],
    limit: '다음 사고가 나기 전에',
  },
};

export const SPEAKERS = {
  me: { name: '서지안', title: '형사', tone: 'me' },
  moon: { name: '문 대장', title: '광역수사대장', tone: 'gray' },
  kwak: { name: '곽 경사', title: '광역수사대', tone: 'orange' },
  eunho: { name: '윤은호', title: '국과수 연구관', tone: 'blue' },
  song: { name: '송영만', title: '유족회 대표', tone: 'amber' },
  byun: { name: '변재만', title: '한성그룹 회장', tone: 'red' },
  yeom: { name: '염 씨', title: '별장 관리인', tone: 'green' },
  ji: { name: '지 대리', title: '창고 직원', tone: 'violet' },
  clerk: { name: '경리 직원', title: '음성 식품공장', tone: 'gray' },
  nam: { name: '남기찬', title: '공장장', tone: 'rose' },
  vendor: { name: '승강기 업체 직원', title: '화성 창고 담당', tone: 'gray' },
  desk: { name: '안내 데스크 직원', title: '한성 본사', tone: 'gray' },
  staff: { name: '과학관 직원', title: '서해과학관', tone: 'gray' },
};

export const CLUES = {
  files: {
    name: '세 건의 사고 기록',
    kind: '물증',
    text: '2024년 2월 홍천 감전(구상철), 7월 화성 추락(표영달), 11월 부산 화재(최동환). 세 사람 모두 꺼진 안전장치 옆에서 죽었다.',
  },
  judgment: {
    name: '한성물류센터 판결문',
    kind: '물증',
    text: '2010년 12월 11일 화재로 아홉 명 사망. 피고인은 변재만, 최동환, 남기찬, 표영달, 구상철. 다섯 모두 집행유예나 벌금. 그중 셋이 죽었다.',
  },
  bypass1: {
    name: '홍천의 우회 전선',
    kind: '물증',
    text: '야외 욕조 회로의 누전차단기를 건너뛰는 전선. 끝의 흰 라벨에 39-92-7.',
  },
  pump: {
    name: '욕조 펌프',
    kind: '물증',
    text: '전원선 피복이 금속 받침대에 닿는 자리만 벗겨져 있다. 접지선은 단자에서 풀려 있다. 당시 기록은 「노후에 의한 마모」.',
  },
  pumpCut: {
    name: '펌프 분석 결과',
    kind: '물증',
    text: '국과수 분석. 피복은 닳은 것이 아니라 칼로 벗긴 것이다. 접지선 나사는 드라이버로 돌려 풀었다.',
  },
  note1: {
    name: '홍천의 메모',
    kind: '물증',
    text: '사고 한 달 전 점검표. 「누전차단기 직결 요청받음. 누전 시 차단되지 않음. 복구 요망. 관리자 서명 거부.」',
  },
  bypass2: {
    name: '화성의 우회 전선',
    kind: '물증',
    text: '2층 승강기 문 잠금장치를 건너뛰는 전선. 칸이 없어도 문이 열린다. 끝의 흰 라벨에 39-92-7.',
  },
  bulb: {
    name: '풀려 있던 전구',
    kind: '물증',
    text: '2층 승강장 전등은 수명이 다한 것이 아니라 반 바퀴 풀려 있었다. 사고 전날 갈아 끼운 새 전구다. 창이 없는 승강장이다.',
  },
  textMsg: {
    name: '선불폰 문자',
    kind: '물증',
    text: '사고 당일 20시 41분, 표영달에게 온 문자. 2층 승강기에 실어 둔 상자의 수량을 급히 확인해 달라는 내용. 발신 번호는 닷새 만에 해지된 선불폰.',
  },
  note2: {
    name: '화성의 메모',
    kind: '물증',
    text: '사고 3주 전 점검표. 「문 잠금장치 우회 요청받음. 칸이 없어도 문이 열림. 복구 요망. 관리자 서명 거부.」',
  },
  busanReport: {
    name: '부산 화재 조사 보고서',
    kind: '물증',
    text: "원인은 전기 히터 과열. 과열 방지 장치가 전선으로 우회돼 있었고 「사용자의 요청에 따른 개조」로 판단. 절반이 탄 현장 점검표에 '복구 요망. 관리자 서명 거부' 메모. 서명란은 타고 없다. 조사자 윤은호.",
  },
  bypass3: {
    name: '부산의 우회 전선',
    kind: '물증',
    text: '히터의 과열 방지 장치를 건너뛰는 전선. 반쯤 녹은 흰 라벨에 39-92-7. 넉 달 전에도 거기 있었다. 온도 조절 손잡이는 최고 단에서 접착제로 굳혀져 있었다.',
  },
  noPart: {
    name: '없는 품번',
    kind: '물증',
    text: '39-92-7이라는 품번은 어느 제조사에도, 어느 자재상에도 없다.',
  },
  daesung: {
    name: '1년 전의 점검표',
    kind: '물증',
    text: '대성제분 경비실에서 찍어 둔 사진. 같은 문구, 같은 글씨, 같은 서명. 내 눈에는 윤, ㅅ, ㅎ으로 보인다. 그 유지보수 업체는 폐업했고 직원 명단이 없다.',
  },
  handwriting: {
    name: '필적 대조 결과',
    kind: '물증',
    text: '홍천, 화성, 부산의 메모는 같은 사람의 글씨일 가능성이 매우 높다. 점검자 서명은 흘려 써서 판독 불가.',
  },
  posts: {
    name: '유족회 게시글',
    kind: '물증',
    text: '세 사람이 죽을 때마다 이틀 안에 올라왔다. 「하나 갔다.」 「둘.」 「셋. 하늘이 무심하지 않다.」 작성자 송영만.',
  },
  alibi: {
    name: '채증 사진',
    kind: '물증',
    text: '세 사고가 난 날 모두 송영만은 서울 법원 앞에서 피켓을 들고 있었다. 경찰이 찍어 둔 사진에 세 번 다 있다.',
  },
  nineNames: {
    name: '아홉 장의 영정',
    kind: '물증',
    text: '한성물류센터 화재의 희생자들. 그중 한 액자에 부부가 있다. 윤태준(48), 김연희(46).',
  },
  fourthNote: {
    name: '네 번째 메모',
    kind: '물증',
    text: '음성 식품공장, 지난주 화요일. 「산소 경보 차단 요청받음. 탱크 출입 시 질식 위험. 복구 요망. 관리자 서명 거부.」 공장장은 남기찬.',
  },
  ceremony: {
    name: '창립 기념식 현수막',
    kind: '물증',
    text: '한성그룹 창립 30주년 기념식. 6월 13일, 본사 지하 컨벤션홀. 임직원과 협력사 천 명.',
  },
  witness: {
    name: '점검 기사에 대한 기억',
    kind: '증언',
    text: '지 대리의 말. 젊고, 모자에 마스크. 나가며 「이거 건너뛰어 두시면, 문 뒤에 뭐가 없어도 문은 열립니다」라고 했고, 「예전에도 이렇게 꺼 두셨습니까」 하고 물었다.',
  },
  noName: {
    name: '이름 없는 하청',
    kind: '증언',
    text: '화성 승강기 업체의 말. 그날 점검은 하청의 하청으로 나갔고 장부에는 「보조 인력 1인」뿐이다. 일당은 현금. 점검표에 적힌 자격 번호의 주인은 그 현장에 가 본 적도 없다.',
  },
  rescueRule: {
    name: '구하러 들어가지 말 것',
    kind: '증언',
    text: '윤은호의 말. 질식 사망자 열에 둘 가까이는 구하러 들어간 사람이다. 가스를 잠그고 바람부터 넣는다. 방진 마스크는 산소를 만들어 주지 못한다. 공기통과 구명줄.',
  },
  knew: {
    name: '더 안 본 것',
    kind: '증언',
    text: '윤은호는 부산에서 죽은 사람이 누구인지 알고 조사했다. 보고서는 본 대로 썼고 숨긴 것은 없다. 다만 그 선을 누가 달았는지는 묻지 않았다.',
  },
  twoSons: {
    name: '윤 선생의 두 아들',
    kind: '기억',
    text: '송영만의 말. 큰아들은 장례 내내 서류만 들여다봤고, 작은아들은 재판 날마다 맨 앞줄에서 피고인들의 얼굴만 봤다.',
  },
  fridge: {
    name: '냉장고의 쪽지 두 장',
    kind: '기억',
    text: '2월, 윤은호의 집 냉장고에 붙어 있던 어릴 적 쪽지. 동생이 자기 방문에 붙였던 「11 · 31」과 윤은호가 그 밑에 붙인 답장 「28 · 31 · 31」. 아버지에게 배운 대로 원자 번호로 쓴 글이다. 나가. 니가 가.',
  },
};

export const INTRO = [
  n('4월 5일 토요일, 밤 아홉 시. 서해과학관 옥상 천문대.'),
  n('12월부터 토요일 저녁은 거의 여기서 보냈다. 1월에 윤은호는 2인 연간 회원권을 끊어 와서 카드 한 장을 내게 줬다. 해설 봉사자는 그냥 들어올 수 있는데도, 나와 올 때는 손님으로 오고 싶다고 했다.'),
  n('망원경 앞에는 줄이 길었다. 벤치에 앉아 차례를 기다리다가 나는 윤은호의 어깨에 기대 잠이 들었다. 그 주는 인수인계로 내내 밤이 늦었다.'),
  n('눈을 떠 보니 줄은 없고, 직원이 망원경에 덮개를 씌우고 있었다.'),
  me('왜 안 깨웠어요.'),
  say('eunho', '잘 자길래요. 목성은 다음 주에도 있어요.'),
  n('윤은호는 일어서면서 왼쪽 어깨를 몇 번 돌렸다. 한 시간을 같은 자세로 앉아 있었던 것이다.'),
  say('eunho', '다음 주도 올 거죠.'),
  me('올게요.'),
  n('4월 7일 월요일, 아침 아홉 시. 광역수사대.'),
  n('모항 펜션 사건 뒤로 넉 달. 지난달 발령이 났고, 오늘이 첫 출근이다. 강 팀장은 송별회에서 한마디만 했다. 「가서도 쉬운 답은 고르지 마.」'),
  say('moon', '서지안 경위. 여긴 신참한테 사건부터 안 줘. 저 상자부터 봐.'),
  n("문 대장이 턱으로 가리킨 곳에 서류 상자가 여섯 개 쌓여 있었다. 지난 2년간 전국에서 '사고사'로 종결된 변사 사건의 기록이다."),
  say('moon', '혹시 놓친 게 있나 훑어보는 일이야. 대개는 없어. 석 달이면 끝나.'),
  n('사고로 닫지 마라. 박 반장의 마지막 말이 떠올랐다. 나는 첫 상자의 뚜껑을 열었다.'),
  n('그날 오후, 두 번째 상자에서 서류 세 건이 손에 걸렸다. 강원 홍천, 경기 화성, 부산 기장. 서로 수백 킬로미터 떨어진 곳에서, 서로 다른 방식으로 죽은 세 사람.'),
  n('세 건의 종결 보고서에는 같은 문장이 하나씩 들어 있었다. 「사고 당시 해당 안전장치는 작동하지 않는 상태였음.」'),
  say('kwak', '서 경위, 그 눈 뭐야. 석 달짜리 서류 일을 3년짜리로 만들 눈인데.'),
  n('곽 경사. 14년 차. 나와 한 조가 된 것을 아직 받아들이지 못한 얼굴이다.'),
  say('sys', '전국의 현장을 다시 조사하고, 사람들을 만나고, 단서를 모으세요. 준비가 되면 [추리하기]로 문 대장에게 보고합니다.'),
];

// What 윤은호 says about the pump is the same whenever she comes to hear it.
const pumpTalk = [
  n('윤은호는 홍천의 펌프 전원선을 현미경 밑에 놓고 화면을 내 쪽으로 돌렸다.'),
  say('eunho', '피복이 닳아서 벗겨지면 가장자리가 보풀처럼 일어납니다. 여기는 가장자리가 곧고 매끈해요. 날이 지나간 자리입니다.'),
  say('eunho', '닳은 게 아니에요. 칼로 벗긴 겁니다. 딱 금속 받침대에 닿는 자리만요.'),
  say('eunho', '접지선 나사도 봤습니다. 풀려서 빠진 게 아니라, 드라이버로 돌려서 푼 자국이 있어요.'),
];

export const LOCATIONS = [
  {
    id: 'hq',
    name: '광역수사대',
    desc: '지방청 별관 3층. 책상마다 서류가 산처럼 쌓여 있다. 내 자리에는 변사 종결 기록 상자 여섯 개와, 곽 경사가 말없이 올려놓고 간 박카스 한 병이 있다.',
    hotspots: [
      {
        id: 'files',
        label: '세 건의 사고 기록을 읽는다',
        variants: [
          {
            lines: [
              n('「2024년 2월 18일, 강원 홍천. 구상철(64), 전직 소방 공무원. 별장 야외 온수 욕조에서 감전사. 낡은 누전차단기의 고장으로 종결.」'),
              n('「2024년 7월 9일, 경기 화성. 표영달(58), 소방 점검업체 대표. 자기 회사 창고의 화물용 승강기 통로로 추락사. 문 잠금장치의 고장으로 종결.」'),
              n('「2024년 11월 21일, 부산 기장. 최동환(61), 창고업. 개인 창고 화재로 사망. 전기 히터 과열로 종결.」'),
              n('누전차단기, 문 잠금장치, 과열 방지 장치. 세 사람 모두, 자기를 지켜 줬어야 할 장치가 꺼진 자리에서 죽었다.'),
              n('그리고 세 사람 모두 소방이나 창고와 얽힌 일을 했다. 우연이라기엔 겹치는 것이 많다.'),
            ],
            gives: ['files'],
          },
        ],
      },
      {
        id: 'names',
        label: '세 사람의 이름을 판결문 검색에 넣어 본다',
        showWhen: { clue: 'files' },
        variants: [
          {
            lines: [
              n('법원 판결문 검색에 세 이름을 차례로 넣었다. 세 이름이 한 사건에서 만났다.'),
              n('「2012년 선고. 한성물류센터 화재 사건. 업무상과실치사.」 2010년 12월 11일 밤, 물류센터에 불이 나 야간 작업자 아홉 명이 숨졌다.'),
              n('스프링클러 밸브는 잠겨 있었다. 경보는 꺼져 있었다. 비상구는 자물쇠로 잠겨 있었다.'),
              n('피고인은 다섯. 한성물류 대표 변재만, 현장 이사 최동환, 안전관리자 남기찬, 소방 점검업체 대표 표영달, 관할 소방서 점검 담당 구상철.'),
              n('다섯 명 모두 집행유예나 벌금으로 풀려났다. 그중 셋이 지난 14개월 사이에 죽었다. 꺼진 안전장치 옆에서.'),
              n('물류센터, 잠긴 스프링클러, 12월 11일. 지난겨울 윤은호가 말했었다. 고3 때 부모님이 물류센터 화재로 돌아가셨다고. 스프링클러가 잠겨 있었다고. 기일은 12월 11일이라고.'),
              n('같은 불인지는 아직 모른다. 나는 그 생각을 일단 접어 두었다.'),
            ],
            gives: ['judgment'],
          },
        ],
      },
      {
        id: 'partNo',
        label: '라벨의 번호를 조회한다',
        showWhen: [{ clue: 'bypass1' }, { clue: 'bypass2' }],
        variants: [
          {
            lines: [
              n('홍천과 화성의 우회 전선에 붙어 있던 흰 라벨. 39-92-7.'),
              n('전선 제조사 세 곳, 전기 자재 도매상 다섯 곳에 물었다. 대답은 같았다. 그런 품번은 없고, 규격 번호도 아니라고 했다.'),
              say('kwak', '품번이 아니면 뭐야. 자기만 아는 정리 번호?'),
              n('품번이 아닌 숫자를, 누군가 멀리 떨어진 현장마다 똑같이 붙여 놓았다.'),
            ],
            gives: ['noPart'],
          },
        ],
      },
      {
        id: 'daesung',
        label: '1년 전 대성제분 기록을 꺼낸다',
        showWhen: { clue: 'note1' },
        variants: [
          {
            lines: [
              n('홍천의 메모를 보는 순간 알았다. 이 글씨, 본 적이 있다.'),
              n('작년 3월 대성제분 화재. 정문 경비실의 화재 경보 장치 옆에 걸려 있던 점검표를 그때 사진으로 찍어 뒀다.'),
              n('「차단 상태로 운영 시 화재 감지 불가. 복구 요망.」 「관리자 서명 거부.」 꾹꾹 눌러 쓴 같은 글씨. 흘려 쓴 서명도 같다. 내 눈에는 이렇게 읽힌다. 윤, 그리고 ㅅ, ㅎ.'),
              n('윤. 흔한 성이다. 나는 거기서 생각을 멈췄다.'),
              n('대성제분의 유지보수 업체에 전화를 걸었다. 없는 번호다. 세무서에 물으니 작년 여름에 폐업 신고를 했고, 직원 명단은 남아 있지 않다고 한다.'),
            ],
            gives: ['daesung'],
          },
        ],
      },
      {
        id: 'photos',
        label: '송영만의 그날 행적을 확인한다',
        showWhen: { clue: 'posts' },
        variants: [
          {
            lines: [
              n("송영만은 14년째 화요일과 목요일마다 서울 법원 앞에서 1인 시위를 한다. 관할 경찰서는 그때마다 그를 찍어 뒀다. '집회 관리' 명목의 채증 사진이다."),
              n('2024년 2월 18일, 7월 9일, 11월 21일. 세 날짜의 사진을 요청했다.'),
              n('세 장 모두에 그가 있다. 같은 피켓, 같은 자리. 2월 18일은 일요일인데도 그는 거기 서 있었다. 사진 뒷면에 담당 경찰이 적어 놓았다. 「부인 생일이라 나왔다고 함.」'),
              n('14년 동안 그를 귀찮아하며 찍어 둔 사진이, 그의 알리바이가 됐다.'),
            ],
            gives: ['alibi'],
          },
        ],
      },
      {
        id: 'calls',
        label: '살아 있는 두 사람의 사업장에 전화를 건다',
        showWhen: [{ clue: 'judgment' }, { clue: 'handwriting' }],
        variants: [
          {
            lines: [
              n('다섯 중 셋이 죽었다. 남은 사람은 둘. 한성그룹 회장 변재만, 그리고 당시 안전관리자였던 남기찬. 지금은 충북 음성의 식품공장 공장장이다.'),
              n('세 번의 죽음 앞에는 매번 같은 글씨의 메모가 있었다. 나는 두 사람의 사업장에 전화를 걸어 같은 질문을 했다. 최근 점검표에 이런 메모가 있습니까.'),
              n('한성그룹 본사의 방재실은 그런 메모는 없다고 했다.'),
              n('음성 식품공장의 경리 직원은 한참 서류를 뒤적이다 말했다.'),
              say('clerk', '있어요. 지난주 화요일 거요. 「식용유 저장 탱크 산소 경보 차단 요청받음. 차단 상태에서 탱크 출입 시 질식 위험. 복구 요망.」 그 밑에 「관리자 서명 거부.」'),
              say('clerk', '공장장님이 경보가 자꾸 헛울려서 생산이 멈춘다고 끄라고 하셨거든요. 근데 형사님, 이게 무슨 문제예요?'),
              me('공장장님 바꿔 주세요. 그리고 그 경보, 지금 다시 켜세요.'),
              say('clerk', '공장장님은 출장 중이세요. 돌아오시면 바로 전해 드릴게요. 경보는 공장장님 허락 없이는 저희가 못 건드려요.'),
              n('메모를 사진으로 찍어 보내 달라고 하고 내 번호를 남겼다. 공장장에게서는 전화가 오지 않았다. 이 한 장으로 문 대장을 움직여야 한다.'),
            ],
            gives: ['fourthNote'],
          },
        ],
      },
      {
        id: 'vendors',
        label: '기사를 보낸 업체들에 전화를 건다',
        showWhen: [{ clue: 'note1' }, { clue: 'note2' }, { clue: 'witness' }],
        variants: [
          {
            lines: [
              n('화성 창고의 승강기 업체부터 걸었다. 작년 6월 점검에 누구를 보냈느냐고 물었다.'),
              say('vendor', '그날은 일손이 모자라서 하청을 줬습니다. 그 하청이 또 사람을 불러 썼고요. 우리 장부에는 「보조 인력 1인」이라고만 돼 있네요. 일당은 현금으로 나갔습니다.'),
              n('점검표 맨 아래에 찍힌 자격 번호를 조회했다. 번호의 주인은 예순이 넘은 기술자였다. 화성에는 가 본 적도 없다고 했다. 이름만 걸어 달라고 해서 번호를 빌려줬을 뿐이라고.'),
              n('홍천 별장에 기사를 보낸 전기 점검 업체는 전화를 받지 않았다. 세무서에 물으니 작년 가을에 폐업 신고를 했다고 한다.'),
              say('kwak', '하청의 하청에, 남의 자격 번호에, 현금 일당이라. 증인치고는 이름을 너무 안 남겼네.'),
            ],
            gives: ['noName'],
          },
        ],
      },
    ],
  },
  {
    id: 'hwaseong',
    name: '화성 창고',
    desc: '경기 화성의 3층짜리 소방 자재 창고. 죽은 표영달의 회사는 아들이 물려받았다. 건물 한가운데에 화물용 승강기가 있다. 사고 뒤로 2층 승강장은 막아 두고 쓰지 않는다. 사람은 타면 안 되고 짐만 싣는 승강기다.',
    hotspots: [
      {
        id: 'door',
        label: '2층 승강기 문을 본다',
        variants: [
          {
            lines: [
              n('2층 승강장의 철문. 승강기 칸이 그 층에 와 있을 때만 열리도록 잠금장치가 달려 있다. 칸이 없는데 문이 열리면, 문 뒤는 빈 통로다.'),
              n('잠금장치의 단자 두 개를 짧은 전선이 건너뛰어 잇고 있다. 이러면 문을 잡아 주는 걸쇠는 칸이 있든 없든 늘 풀려 있다. 기계는 그래도 문이 잠겼다고 믿는다. 문은 칸이 어디 있든 손으로 열린다.'),
              n('당시 수사는 「잠금장치 노후 고장」으로 적었다. 이 전선에 대해서는 「임시 조치로 보임」 한 줄뿐이다.'),
              n('전선 끝을 감싼 흰 라벨에 작은 숫자가 인쇄돼 있다. 39-92-7.'),
            ],
            gives: ['bypass2'],
          },
        ],
      },
      {
        id: 'bulb',
        label: '2층 승강장의 전등을 본다',
        variants: [
          {
            lines: [
              n('승강기 문 바로 위 천장에 전등이 하나 있다. 사고 당시 꺼져 있었다고 기록돼 있다. 「전구 수명 다함」.'),
              n('의자를 놓고 올라가 전구를 만져 봤다. 헐겁다. 반 바퀴를 돌리자 불이 들어왔다.'),
              n('1층 사무실의 소모품 대장을 확인했다. 이 전구는 사고 바로 전날 새것으로 갈았다.'),
              n('창이 없는 승강장이다. 전구를 다시 반 바퀴 풀어 봤다. 내 손도 보이지 않았다.'),
            ],
            gives: ['bulb'],
          },
        ],
      },
      {
        id: 'phonelog',
        label: '사건 기록의 통화 내역을 본다',
        variants: [
          {
            lines: [
              n('표영달의 휴대폰 기록. 사고 당일 저녁 8시 41분에 받은 문자가 마지막이다.'),
              n('「대표님, 내일 아침 납품할 스프링클러 헤드 상자를 2층 승강기에 실어 뒀습니다. 수량만 확인 부탁드립니다. 급합니다.」'),
              n('발신 번호는 거래처 어디에도 없는 번호다. 개통 닷새 만에 해지된 선불폰.'),
              n('직원들이 다 퇴근한 저녁, 표영달은 이 문자를 받고 혼자 2층으로 올라갔다. 다음 날 아침, 2층 승강기 문은 열려 있었다.'),
            ],
            gives: ['textMsg'],
          },
        ],
      },
      {
        id: 'sheet',
        label: '1층 사무실의 점검표를 본다',
        variants: [
          {
            lines: [
              n('승강기 정기 점검표. 2024년 6월, 사고 3주 전.'),
              n('「2층 승강장 문 잠금장치 우회 요청받음. 우회 상태에서는 칸이 없어도 문이 열림. 복구 요망.」 「관리자 서명 거부.」'),
              n('볼펜으로 꾹꾹 눌러 쓴 글씨다. 점검자 서명은 흘려 써서 읽기 어렵다.'),
            ],
            gives: ['note2'],
          },
        ],
      },
    ],
  },
  {
    id: 'hongcheon',
    name: '홍천 별장',
    desc: '강원 홍천의 산자락에 있는 2층 별장. 주인이 죽은 뒤로 14개월째 비어 있다. 마당의 야외 온수 욕조에는 덮개가 씌워져 있고, 관리인 염 씨가 일주일에 한 번 들러 낙엽을 치운다.',
    hotspots: [
      {
        id: 'panel',
        label: '분전함을 연다',
        variants: [
          {
            lines: [
              n('현관 옆 분전함. 맨 끝의 차단기에 「야외 욕조」라고 적혀 있다. 누전차단기다. 전기가 조금이라도 새면 눈 깜짝할 사이에 끊어 주는 장치.'),
              n('그런데 차단기의 위쪽 단자와 아래쪽 단자를 짧은 전선 두 가닥이 건너뛰어 잇고 있다. 전기는 차단기를 지나지 않고 이 전선으로 흐른다. 차단기는 달려만 있고 아무 일도 하지 않는다.'),
              n('당시 수사 기록에는 이 전선 얘기가 한 줄도 없다.'),
              n('전선 한 가닥의 끝을 감싼 흰 라벨에 작은 숫자가 인쇄돼 있다. 39-92-7.'),
            ],
            gives: ['bypass1'],
          },
        ],
      },
      {
        id: 'pump',
        label: '욕조의 순환 펌프를 본다',
        variants: [
          {
            lines: [
              n('욕조 밑 점검구를 열었다. 물을 데워 돌리는 순환 펌프. 사고 뒤로 아무도 손대지 않았다.'),
              n('펌프의 전원선이 금속 받침대에 닿는 자리에서 피복이 벗겨져 구리가 드러나 있다. 당시 기록은 「노후에 의한 마모」.'),
              n('초록색 접지선은 단자에서 빠져 덜렁거린다. 나사는 풀린 채 단자에 그대로 꽂혀 있다.'),
              n('접지선은 새는 전기를 땅으로 흘려보내는 선이다. 그 선이 풀려 있었다. 그리고 그 물에 사람이 들어갔다.'),
              n('펌프를 떼어 증거물 봉투에 넣었다. 닳은 것인지 벗긴 것인지, 봐 줄 사람이 있다.'),
            ],
            gives: ['pump'],
          },
        ],
      },
      {
        id: 'sheet',
        label: '보일러실의 점검표를 본다',
        variants: [
          {
            lines: [
              n('보일러실 벽에 전기 안전 점검표가 걸려 있다. 2024년 1월, 사고 한 달 전.'),
              n('「욕조 회로 누전차단기 직결 요청받음. 직결 상태에서는 누전 시 차단되지 않음. 복구 요망.」'),
              n('그 아래 한 줄이 더 있다. 같은 글씨로. 「관리자 서명 거부.」'),
              n('볼펜으로 꾹꾹 눌러 쓴 글씨다. 점검자 서명은 흘려 써서 읽기 어렵다.'),
            ],
            gives: ['note1'],
          },
        ],
      },
    ],
  },
  {
    id: 'nfs',
    name: '국과수',
    desc: '국립과학수사연구원. 윤은호의 실험실은 2층 복도 끝이다. 문에 붙은 이름표 밑에 누가 포스트잇을 붙여 놨다. 「Y-U-N-Eu-N-Ho 박사님은 오늘도 야근」. 후배들 짓이다.',
    hotspots: [
      {
        id: 'pumpResult',
        label: '펌프 분석 결과를 듣는다',
        showWhen: { clue: 'pump' },
        variants: [
          {
            // After the talk about the 부산 report, the same result without the warmth.
            when: [{ clue: 'knew' }, { flag: 'pills' }],
            lines: [
              ...pumpTalk,
              n('윤은호는 결과만 말하고 화면으로 눈을 돌렸다. 나도 고맙다는 말만 하고 나왔다.'),
              n('출장 가방 옆주머니에는 윤은호가 넣어 준 멀미약이 뜯지 않은 채 그대로 있다.'),
            ],
            gives: ['pumpCut'],
          },
          {
            // The same, for a player who comes here for the first time that late: there were no pills.
            when: { clue: 'knew' },
            lines: [
              ...pumpTalk,
              n('윤은호는 결과만 말하고 화면으로 눈을 돌렸다. 나도 고맙다는 말만 하고 나왔다.'),
            ],
            gives: ['pumpCut'],
          },
          {
            lines: [
              ...pumpTalk,
              n('닳은 자리와 벤 자리는 내 눈에도 달라 보였다. 나는 그 화면을 휴대폰으로 찍었다.'),
              n('윤은호가 내 출장 가방 옆주머니에 뭔가를 밀어 넣었다. 멀미약이다.'),
              say('eunho', '이번 주 내내 길 위라면서요. 곽 경사님 운전이 거칠다고 했잖아요, 지안 씨.'),
            ],
            gives: ['pumpCut'],
            flag: 'pills',
          },
        ],
      },
      {
        id: 'report',
        label: '부산 화재 조사 보고서를 본다',
        showWhen: { clue: 'files' },
        variants: [
          {
            lines: [
              n('세 번째 사고, 부산 기장 창고 화재의 조사 보고서. 국과수에서 작성했다.'),
              n('「발화 원인: 전기 히터 과열. 히터 내부의 과열 방지 장치가 전선으로 우회돼 있었음. 사용자의 요청에 따른 개조로 판단.」'),
              n("「화재 경보 장치는 차단 상태. 비상구는 쌓아 둔 짐으로 막혀 있었음. 현장 점검표는 절반이 탔음. 남은 부분에서 '우회 요청받음', '복구 요망. 관리자 서명 거부' 문구 확인. 서명란은 타고 없음.」"),
              n('결론은 사고. 나는 마지막 장을 넘겼다. 조사자 서명란.'),
              n('윤은호.'),
            ],
            gives: ['busanReport'],
          },
        ],
      },
      {
        id: 'heater',
        label: '히터 잔해를 윤은호와 함께 다시 본다',
        showWhen: [{ clue: 'busanReport' }, { clue: 'bypass1' }],
        variants: [
          {
            lines: [
              me('은호 씨. 부산 히터, 다시 볼 수 있어요?'),
              say('eunho', '…제 보고서에 문제가 있습니까.'),
              me('홍천에서 본 게 있어요. 안전장치를 건너뛰는 전선. 그 전선에 붙은 숫자.'),
              n('윤은호는 대답 대신 보관실에서 상자를 꺼내 왔다. 넉 달 전 자기 손으로 봉인한 상자다.'),
              say('eunho', '과열 방지 장치를 건너뛰는 전선입니다. 히터가 자꾸 꺼진다고 주인이 이렇게 해 달라고 하는 일이 많아요. 타다 남은 점검표에도 요청받았다고 적혀 있었고요. 그래서 저는…'),
              n('윤은호가 그을린 전선을 뒤집었다. 반쯤 녹은 흰 라벨에 숫자 세 개가 남아 있다.'),
              say('eunho', '39, 92, 7.'),
              n('윤은호는 숫자를 읽고 그대로 멈췄다. 전선을 든 손이 내려오지 않았다. 얼굴에서 핏기가 빠졌다.'),
              me('은호 씨?'),
              say('eunho', '…있었네요. 그때도 여기 있었을 텐데.'),
              say('eunho', '제가 놓쳤습니다.'),
              n('넉 달 전에 놓친 것을 이제야 본 사람의 얼굴이라고, 나는 생각했다.'),
              n('윤은호는 장갑을 끼고 히터를 처음부터 다시 봤다. 이번에는 오래 걸렸다.'),
              say('eunho', '온도 조절 손잡이입니다. 최고 단에서 굳어 있어요. 불에 녹아 붙은 줄 알았는데… 틈에 낀 건 녹은 플라스틱이 아니라 탄 접착제입니다.'),
              say('eunho', '전선은 주인이 시킨 일일 수 있습니다. 하지만 손잡이를 최고 단에 붙여 놓은 건 주인이 아닙니다. 이 히터는 꺼지지도, 약해지지도 않게 만들어져 있었어요. …보고서는 오늘 정정해서 올리겠습니다.'),
            ],
            gives: ['bypass3'],
          },
        ],
      },
      {
        id: 'compare',
        label: '세 장의 메모를 윤은호에게 보여 준다',
        showWhen: [{ clue: 'note1' }, { clue: 'note2' }, { clue: 'busanReport' }, { clue: 'knew' }],
        variants: [
          {
            lines: [
              n('홍천, 화성, 부산. 세 현장의 점검표 메모를 윤은호의 책상에 나란히 놓았다.'),
              me('같은 사람 글씨 같아요. 문서 분석실에 필적 대조를 맡기려고요.'),
              n('윤은호는 아무 말도 하지 않았다. 세 장을 하나씩 들어 불빛에 비춰 봤다. 부산 것은 서명란이 타고 없다. 윤은호의 손끝이 홍천과 화성의 서명 위에서 멈췄다.'),
              n("이튿날 오후, 급하게 맡긴 필적 대조의 회신이 왔다. 「세 문서의 필적은 같은 사람의 것일 가능성이 매우 높음. 'ㅂ'의 획 순서와 '요'의 기울기에서 드물고 일정한 습관이 확인됨. 점검자 서명은 흘려 써서 판독 불가.」"),
              n('그 결과를 전하러 갔을 때, 윤은호는 창밖을 보고 있었다.'),
              say('eunho', '지안 씨. 이 글씨 쓴 사람, 찾고 있죠.'),
              me('증인이니까요. 세 번 다 경고를 남긴 사람이에요. 뭔가 봤을 거예요.'),
              n('윤은호는 고개만 끄덕였다. 결과지는 읽지 않고 책상에 내려놓았다.'),
              me('은호 씨. 부산 일은 이 사건 끝나고 다시 얘기해요. 다음 주 토요일에요.'),
              say('eunho', '…시간을 좀 주세요. 확인해 볼 데가 있습니다.'),
              n('확인해 볼 데가 어디냐고는 묻지 않았다. 내 귀에는 시간을 달라는 말만 남았다. 부산 일 때문에 나를 보기가 힘든 것이라고 생각했다.'),
              me('알았어요. 기다릴게요.'),
              say('eunho', '대조 결과는 그대로 올리세요.'),
              n('윤은호는 그 말을 하면서 나를 보지 않았다.'),
            ],
            gives: ['handwriting'],
          },
        ],
      },
    ],
  },
  {
    id: 'bereaved',
    name: '유족회',
    showWhen: { clue: 'judgment' },
    desc: '서울 변두리 상가 2층. 「한성물류센터 화재 참사 유족회」 간판은 14년 치 햇볕에 바랬다. 벽 한 면에 영정 사진 아홉 장이 걸려 있고, 그 밑에서 송영만이 피켓의 글씨를 덧칠하고 있다.',
    hotspots: [
      {
        id: 'wall',
        label: '벽의 영정 사진을 본다',
        variants: [
          {
            lines: [
              n('아홉 장의 사진과 아홉 개의 이름. 2010년 12월 11일 밤, 물류센터에서 야간 분류 작업을 하던 사람들이다.'),
              n('왼쪽에서 네 번째와 다섯 번째는 한 액자에 들어 있다. 부부다. 「윤태준(48) · 김연희(46)」.'),
              n('윤. 그리고 12월 11일.'),
              n('사진 속 남자의 눈매가 누군가를 닮았다. 나는 그 액자 앞에 오래 서 있었다.'),
            ],
            gives: ['nineNames'],
          },
        ],
      },
      {
        id: 'posts',
        label: '유족회 게시판 출력물을 본다',
        variants: [
          {
            lines: [
              n('책상 위에 유족회 게시판 글을 뽑은 종이가 놓여 있다. 송영만은 그것을 치우지도 않았다.'),
              n('2024년 2월 20일. 「구상철이 갔다. 하나 갔다.」 7월 11일. 「표영달. 둘.」 11월 23일. 「최동환. 셋. 하늘이 무심하지 않다.」'),
              n('세 사람이 죽을 때마다 이틀 안에 글이 올라왔다. 작성자, 송영만.'),
              n('수사대가 왜 이 사람부터 의심하는지, 이 종이 한 장이면 설명이 된다.'),
            ],
            gives: ['posts'],
          },
        ],
      },
    ],
  },
  {
    id: 'hansung',
    name: '한성 본사',
    showWhen: { clue: 'judgment' },
    desc: '서울 강남의 20층짜리 사옥. 로비에 「2024 안전경영 대상」 트로피가 유리 상자에 들어 있다. 14년 전의 한성물류는 지금 한성그룹이 됐다. 변재만 회장은 면담 시간으로 정확히 10분을 내줬다.',
    hotspots: [
      {
        id: 'lobby',
        label: '로비를 둘러본다',
        variants: [
          {
            lines: [
              n('트로피 옆에 대형 현수막이 걸려 있다. 「한성그룹 창립 30주년 기념식. 6월 13일. 본사 지하 컨벤션홀.」'),
              n('안내 데스크 직원이 묻지도 않았는데 말했다.'),
              say('desk', '회장님이 직접 기획하신 행사예요. 임직원과 협력사까지 천 명이 옵니다.'),
              n('14년 전 불탄 물류센터의 이름은 이 건물 어디에도 없다.'),
            ],
            gives: ['ceremony'],
          },
        ],
      },
    ],
  },
  {
    id: 'phone',
    name: '휴대폰',
    desc: '출장 가방 옆주머니의 휴대폰. 대화 목록 맨 위에는 늘 같은 이름이 있다. 윤은호.',
    hotspots: [
      {
        id: 'chat',
        label: '윤은호와의 대화를 본다',
        // From the heater scene on, his replies get shorter. The variants are tried latest first.
        variants: [
          {
            when: { clue: 'handwriting' },
            lines: [
              n('필적 대조 결과를 전한 날 밤의 대화방.'),
              n('나: 「기다릴게요. 밥은 잘 챙겨 먹어요.」'),
              n("메시지 옆에 '읽음' 표시가 떴다. 답장은 오지 않았다."),
            ],
          },
          {
            when: { clue: 'knew' },
            lines: [
              n('부산 보고서 얘기를 한 날 밤의 대화방.'),
              n('윤은호: 「오늘은 미안했습니다.」'),
              n('나: 「미안할 일은 아니에요. 그냥, 먼저 말해 줬으면 했어요.」'),
              n('윤은호: 「네.」'),
              n('윤은호에게서 한 글자짜리 답장을 받은 것은 처음이다.'),
            ],
          },
          {
            when: { clue: 'bypass3' },
            lines: [
              n('히터를 같이 본 날 밤의 대화방.'),
              n('윤은호: 「보고서 정정 요청 올렸습니다.」'),
              n('나: 「고마워요. 아까 얼굴이 안 좋던데, 괜찮아요?」'),
              n('윤은호: 「괜찮습니다. 먼저 들어가겠습니다.」'),
              n('평소라면 접착제가 몇 도에서 타는지까지 적어 보냈을 사람이다.'),
            ],
          },
          {
            // The dinner itself is played in the 'dinner' event, which everyone passes after 'trip'.
            when: { flag: 'dinner' },
            lines: [
              n('도시락을 받은 다음 날 아침의 대화가 맨 위에 있다.'),
              n('나: 「잘 먹었어요. 나가 보지도 못했네요. 미안해요.」'),
              n('윤은호: 「식었죠. 다음에는 보온 통에 담아 갈게요.」'),
              n('통은 씻어서 가방에 넣어 뒀다. 토요일에 돌려주면 좋았을 텐데, 이번 토요일은 내가 당직이다.'),
            ],
          },
          {
            // The cancelled Saturday itself is played in the 'trip' event, which everyone passes.
            when: { flag: 'trip' },
            lines: [
              n('휴게소에서 주고받은 대화가 맨 위에 있다.'),
              n('나: 「이번 토요일에 당직이 걸렸어요. 과학관은 못 갈 것 같아요. 미안해요.」'),
              n('윤은호: 「괜찮아요. 당직이면 어쩔 수 없죠. 다음 주에 가요.」'),
              n('조금 뒤에 한 줄이 더 와 있다. 윤은호: 「곽 경사님께 운전 조심하시라고 전해 주세요.」'),
            ],
          },
          {
            lines: [
              n('월요일 아침의 대화.'),
              n('윤은호: 「첫 출근 잘 했어요? 자리는 창가예요?」'),
              n('나: 「서류 상자 여섯 개가 창을 가려요.」'),
              n('윤은호: 「토요일에 옥상에서 실컷 봐요. 이번에는 차례가 오면 깨울게요.」'),
              n('나: 「이번에는 안 잘 거예요.」'),
            ],
          },
        ],
      },
      {
        id: 'album',
        label: '사진첩을 본다',
        showWhen: { flag: 'home' },
        variants: [
          {
            lines: [
              n('2월에 찍은 사진이 한 장 있다. 윤은호가 자기 집 부엌에서 냄비를 든 채 돌아보고 있다. 찍지 말라는 얼굴이다.'),
              n('윤은호의 어깨 너머로 냉장고가 보인다. 쪽지 두 장이 붙어 있다. 「11 · 31」, 그리고 「28 · 31 · 31」.'),
              n('나가. 니가 가. 윤은호의 집 작은방은 지금도 비어 있을 것이다.'),
            ],
            gives: ['fridge'],
          },
        ],
      },
    ],
  },
];

export const VICTIM = {
  id: 'victim',
  name: '구상철',
  age: 64,
  role: '전직 소방 공무원',
  tag: '피해자',
  desc: '2024년 2월 홍천의 별장 온수 욕조에서 감전사. 은퇴한 소방 공무원으로, 주말마다 혼자 별장에 와서 지냈다.',
};

export const PEOPLE = [
  {
    id: 'moon',
    name: '문 대장',
    age: 55,
    role: '광역수사대장',
    tag: '팀',
    loc: 'hq',
    desc: '광역수사대를 8년째 이끌고 있다. 종결된 사고를 다시 여는 일을 달가워하지 않는다. 다만 증거 앞에서는 말을 바꿀 줄 안다고 했다.',
    topics: [
      {
        id: 'task',
        label: '서류 일',
        lines: [
          say('moon', '서류 일이 불만이야? 광수대는 큰 사건만 해. 큰 사건은 서류에서 시작하고.'),
        ],
      },
      {
        id: 'theory',
        label: '수사대의 가설',
        when: { clue: 'judgment' },
        lines: [
          say('moon', '죽은 셋이 한 재판의 피고인이다. 그럼 답은 둘 중 하나야. 유족의 복수거나, 남은 놈의 입막음이거나.'),
          say('moon', '유족회 대표 송영만. 죽을 때마다 글을 올린 양반이지. 아니면 변재만 회장. 유족들이 뇌물과 위증으로 새로 고발장을 냈거든. 옛 공범들이 입을 열면 곤란한 건 그 사람이야.'),
          say('moon', '둘 중 하나를 가져와. 제3의 인물 같은 소리는 증거를 들고 와서 하고.'),
        ],
      },
    ],
    present: {
      pumpCut: {
        lines: [
          say('moon', '칼로 벗겼다… 국과수 소견이면 무시는 못 하지. 한 건은 다시 열 수 있겠어. 한 건은.'),
        ],
      },
      alibi: {
        lines: [
          say('moon', '죽은 날마다 법원 앞에 있었다… 미리 손을 써 놓고 갈 수도 있잖아. 그래도 위에 올릴 얘깃거리는 되겠네.'),
        ],
      },
      handwriting: {
        lines: [
          say('moon', '같은 기사가 세 군데를 다녀갔다. 그 기사를 찾아. 증인이든 뭐든.'),
        ],
      },
      noName: {
        lines: [
          say('moon', '하청의 하청이라… 업체를 털어도 이름이 안 나온다는 거네. 그래도 계속 파.'),
        ],
      },
    },
    fallback: [say('moon', '그래서 결론이 뭐야.')],
  },
  {
    id: 'kwak',
    name: '곽 경사',
    age: 41,
    role: '광역수사대',
    tag: '팀',
    loc: 'hq',
    desc: '14년 차. 서지안과 한 조가 됐다. 전국 출장의 운전을 도맡고, 운전하는 내내 투덜댄다. 투덜대면서도 차를 돌린 적은 없다.',
    topics: [
      {
        id: 'drive',
        label: '운전',
        lines: [
          say('kwak', '홍천 두 시간, 화성 한 시간 반, 부산은 다섯 시간이야. 내 허리 값은 서 경위 월급에서 까.'),
          say('kwak', '…박카스는 내가 놓은 거 맞아. 운전하는 사람이 졸면 안 되니까, 옆 사람도 깨 있으라고.'),
        ],
      },
      {
        id: 'think',
        label: '곽 경사의 생각',
        when: { clue: 'judgment' },
        lines: [
          say('kwak', '나? 나라면 유족부터 봐. 사람은 14년을 못 잊어.'),
          say('kwak', '근데 하나 걸려. 유족이 복수를 한다 치자. 그냥 찌르면 되잖아. 왜 굳이 차단기니 승강기니, 이렇게 공을 들여.'),
          say('kwak', '이건 죽이는 것만으로는 모자란 놈이야. 어떻게 죽는지가 중요한 놈이지.'),
        ],
      },
    ],
    present: {
      witness: {
        lines: [
          say('kwak', '「예전에도 이렇게 꺼 두셨습니까.」 …그 기사, 뭘 알고 물은 거네.'),
        ],
      },
      fourthNote: {
        lines: [
          say('kwak', '음성이면 여기서 한 시간 사십 분이야. …차 키 어디 뒀더라.'),
        ],
      },
    },
    fallback: [say('kwak', '그건 대장한테 물어. 나는 운전 담당이야.')],
  },
  {
    id: 'ji',
    name: '지 대리',
    age: 34,
    role: '창고 직원',
    tag: '참고인',
    loc: 'hwaseong',
    desc: '표영달의 회사에서 9년을 일했다. 사고 다음 날 아침 대표를 처음 발견했다. 죽은 대표 얘기를 할 때 말끝이 조금 차갑다.',
    topics: [
      {
        id: 'day',
        label: '사고가 난 날',
        lines: [
          say('ji', '저는 여섯 시에 퇴근했어요. 다음 날 아침에 출근해 보니 2층 승강기 문이 열려 있었어요. 칸은 3층에 올라가 있었고, 대표님은 통로 맨 밑바닥에… 계셨습니다.'),
        ],
      },
      {
        id: 'lock',
        label: '문 잠금장치',
        lines: [
          say('ji', '2층 문이 자꾸 안 열렸어요. 칸이 정확히 안 서면 잠금이 안 풀리거든요. 대표님이 짐 싣다가 화를 내셨죠. 점검 나온 기사한테 그러셨어요. 「이 잠금장치 죽여 버려.」'),
          say('ji', "웃기죠. 소방 점검하는 회사 대표가요. 남의 건물 안전장치는 돈 받고 '양호' 도장 찍어 주고, 자기 건물 안전장치는 귀찮다고 죽이고."),
        ],
      },
      {
        id: 'tech',
        label: '그 기사',
        lines: [
          say('ji', '승강기 업체에서 보낸 기사였어요. 젊고, 모자에 마스크. 말수가 없고 손이 빨랐죠.'),
          say('ji', '대표님이 서명을 안 해 주니까, 나가면서 한마디 하더라고요. 「이거 건너뛰어 두시면, 문 뒤에 뭐가 없어도 문은 열립니다.」'),
          say('ji', '그리고 하나 더 물었어요. 「예전에도 이렇게 꺼 두셨습니까.」 대표님 얼굴이 하얘졌죠. 저는 그게 무슨 말인지 몰랐고요.'),
        ],
        gives: ['witness'],
      },
    ],
    present: {
      textMsg: {
        lines: [
          say('ji', '승강기에 실어 둔 상자요? 그 주에 납품 건은 없었는데요. 실어 둔 상자도 없었고요.'),
        ],
      },
      bulb: {
        lines: [
          say('ji', '풀려 있었다고요? 그 전구, 사고 전날 제가 갈았어요. 새 전구였는데.'),
        ],
      },
    },
    fallback: [say('ji', '그건 제가 잘 모르겠네요.')],
  },
  {
    id: 'yeom',
    name: '염 씨',
    age: 68,
    role: '별장 관리인',
    tag: '참고인',
    loc: 'hongcheon',
    desc: '홍천 별장을 10년째 돌보는 마을 주민. 월요일 아침 욕조에서 구상철을 발견했다. 주인이 죽은 뒤에도 일주일에 한 번 낙엽을 치우러 온다.',
    topics: [
      {
        id: 'day',
        label: '사고가 난 날',
        lines: [
          say('yeom', '일요일 저녁이었지요. 사장님은 주말마다 혼자 오셔서 욕조에 들어가 소주를 드셨어요. 월요일 아침에 제가 와 보니까… 물에 그대로 계시더라고요.'),
        ],
      },
      {
        id: 'breaker',
        label: '누전차단기',
        lines: [
          say('yeom', '그 욕조가 틀기만 하면 차단기가 떨어졌어요. 사장님이 짜증을 내시다가 기사를 불렀지요. 「이거 안 떨어지게 해 놔」 하고.'),
          say('yeom', '기사가 안 된다고, 위험하다고 몇 번을 말했어요. 사장님이 그랬지요. 「내가 소방서에서 30년을 있었어. 위험한지 아닌지는 내가 알아.」'),
        ],
      },
      {
        id: 'tech',
        label: '그 기사',
        lines: [
          say('yeom', '젊은 사람이었어요. 모자를 눌러쓰고 마스크를 하고. 말수가 없었지요. 일은 깔끔하게 합디다.'),
          say('yeom', '종이에 뭘 적어서 사장님한테 서명하라고 내밀었는데, 사장님이 종이를 쳐 버렸어요. 기사는 그걸 주워서 한 줄을 더 적고 갔습니다.'),
        ],
      },
    ],
    present: {
      bypass1: {
        lines: [
          say('yeom', '그 선이요? 그 기사가 단 거예요. 사장님이 시켜서요. …그럼 그 기사 잘못입니까?'),
          n('그렇게 간단한 문제였으면 좋겠다.'),
        ],
      },
    },
    fallback: [say('yeom', '그건 내가 알 수가 없지요.')],
  },
  {
    id: 'eunho',
    name: '윤은호',
    age: 33,
    role: '국과수 연구관',
    tag: '연인',
    loc: 'nfs',
    desc: '화재와 안전사고의 원인을 조사하는 국과수 연구관. 넉 달째 만나는 사람. 여전히 대답보다 설명이 먼저 나온다.',
    topics: [
      {
        id: 'weekend',
        label: '이번 주말',
        when: { flag: 'trip' },
        lines: [
          say('eunho', '토요일 일은 미안해할 것 없어요. 당직이잖아요. 압니다.'),
          say('eunho', '저도 이번 주는 질식 사고 조사가 하나 잡혀 있어요. 다음 주에 가요, 지안 씨.'),
        ],
      },
      {
        id: 'rescue',
        label: '요즘 맡은 사건',
        lines: [
          say('eunho', '이번 주에 맡은 건 질식 사고입니다. 정화조를 청소하던 분이 쓰러졌는데, 구하러 들어간 동료가 같이 쓰러졌어요. 질식 사고로 죽는 사람 열에 둘 가까이가 그렇게 구하러 들어간 사람입니다.'),
          say('eunho', '산소가 거의 없는 공기는 한두 번 들이마시면 그대로 정신을 잃습니다. 숨이 찬 느낌도 없어요. 질소 같은 건 냄새도 색도 없고요.'),
          say('eunho', '그 동료는 방진 마스크를 쓰고 들어갔더군요. 마스크는 먼지를 거를 뿐입니다. 없는 산소를 만들어 주지는 못해요.'),
          say('eunho', '순서는 하나뿐입니다. 들어가지 말 것. 가스를 잠그고 바람부터 넣을 것. 꼭 들어가야 하면 공기통을 메고, 밖에서 줄을 잡아 줄 사람을 둘 것.'),
          say('eunho', '…지안 씨는 그런 데 뛰어들 사람이라서 하는 말입니다.'),
        ],
        gives: ['rescueRule'],
      },
      {
        id: 'knew',
        label: '윤은호는 알고 있었는가',
        when: [{ clue: 'nineNames' }, { clue: 'bypass3' }],
        lines: [
          me('유족회 사무실에 다녀왔어요. 벽에 아홉 분 이름이 있더군요. 윤태준, 김연희.'),
          n('윤은호는 놀라지 않았다.'),
          say('eunho', '…부모님입니다.'),
          me('부산에서 죽은 사람이 최동환이에요. 14년 전에 비상구를 잠근 현장 이사. 조사할 때 알았어요?'),
          say('eunho', '…알았습니다. 서류에서 이름을 보는 순간.'),
          me('그럼 그 조사에서 빠졌어야죠. 나한테라도 말했어야 하고.'),
          say('eunho', '증거가 사고였습니다. 저는 증거대로 썼어요. 한 줄도 지어내지 않았고, 한 줄도 빼지 않았습니다.'),
          say('eunho', '타다 남은 점검표의 메모도 본 대로 옮겨 적었습니다. 누가 쓴 건지는 알 길이 없었어요. 서명란이 타고 없었으니까요.'),
          me('알아요. 본 대로 썼다는 거. 그래서 묻는 거예요. 평소의 은호 씨라면 그 전선을 누가 달았는지 물었을 거잖아요.'),
          n('윤은호는 오래 말이 없었다.'),
          say('eunho', '놓친 게 아닙니다. 더 안 본 겁니다.'),
          say('eunho', '이름을 보는 순간 생각했어요. 벌받았구나. 그 생각이 드니까 더 볼 이유가 없어졌습니다.'),
          say('eunho', '그 선을 누가 달았는지 물었어야 했습니다. 그게 제 일인데, 그날은 묻지 않았어요.'),
          n('보고서에 거짓은 없다. 숨긴 것도, 감싼 사람도 없다. 윤은호는 다만 거기서 멈췄다. 그리고 그것을 누구보다 무겁게 여기고 있었다.'),
          n('나는 괜찮다고 말하지 못했다. 윤은호도 그 말을 기다리지 않았다.'),
        ],
        gives: ['knew'],
      },
    ],
    present: {
      note1: {
        lines: [
          n('윤은호는 메모를 받아 들고 한참 봤다. 눈이 맨 아래 서명란에 머물렀다.'),
          say('eunho', '…글씨가 반듯하네요. 꾹꾹 눌러 쓰는 사람이에요.'),
          n('그게 전부였다. 윤은호는 메모를 내 손이 아니라 책상 위에 내려놓았다.'),
        ],
      },
      busanReport: {
        lines: [
          n('윤은호는 자기 서명이 있는 마지막 장을 한 번 보고 덮었다.'),
          say('eunho', '제가 쓴 겁니다. 틀린 데가 있으면 말해 주세요. 몇 번이든 고치겠습니다.'),
        ],
      },
      nineNames: {
        lines: [
          n('윤은호는 사진을 받아 들지 않았다. 보지 않아도 아는 얼굴이라는 듯이.'),
          say('eunho', '…그 얘기는 제가 먼저 했어야 했습니다.'),
        ],
      },
      daesung: {
        lines: [
          n('윤은호는 사진을 오래 봤다.'),
          say('eunho', '…기억합니다. 대성제분 경비실에 걸려 있던 점검표죠.'),
          n('윤은호는 그 말만 하고 사진을 돌려줬다.'),
        ],
      },
      handwriting: {
        lines: [
          say('eunho', '결과는 그대로 올리세요. 저는… 조금만 시간을 주세요.'),
        ],
      },
      fourthNote: {
        lines: [
          n('윤은호는 메모의 날짜를 오래 봤다. 지난주 화요일.'),
          say('eunho', '음성이요. …지안 씨, 이건 저한테 보여 줄 시간이 없습니다. 지금 바로 대장님께 가져가세요.'),
        ],
      },
      noPart: {
        lines: [
          me('전선 라벨에 찍힌 번호가 어느 제조사에도 없는 품번이래요.'),
          say('eunho', '품번이 아니면 표시겠죠. 자기가 한 일이라는 표시요. 기술자들은 가끔 그렇게 합니다.'),
          n('윤은호는 현미경에서 눈을 떼지 않고 대답했다. 무슨 번호냐고는 묻지 않았다.'),
        ],
      },
      judgment: {
        lines: [
          say('eunho', '한성물류센터. …네, 압니다. 그 사건.'),
          n('윤은호는 판결문을 끝까지 읽지 않고 돌려줬다. 이미 외우고 있는 사람처럼.'),
        ],
      },
    },
    fallback: [say('eunho', '그건 제가 볼 수 있는 범위 밖이네요.')],
  },
  {
    id: 'song',
    name: '송영만',
    age: 67,
    role: '유족회 대표',
    tag: '용의자',
    loc: 'bereaved',
    desc: '한성물류센터 화재로 아내를 잃었다. 평생 버스를 몰았고, 14년째 법원 앞에서 1인 시위를 한다. 세 사람이 죽을 때마다 유족회 게시판에 글을 올렸다.',
    topics: [
      {
        id: 'years',
        label: '14년',
        lines: [
          say('song', '집사람이 그날 야간 조였소. 스프링클러에서 물 한 방울이 안 나왔답디다. 상품 젖는다고 잠가 놨대.'),
          say('song', '재판에서 그놈들이 뭐라고 했는지 아시오. 「관행이었다.」 아홉이 죽었는데 관행이었대. 그러고 다 걸어 나갔소.'),
        ],
      },
      {
        id: 'write',
        label: '게시글',
        when: { clue: 'posts' },
        lines: [
          say('song', '내가 썼소. 숨길 것도 없지. 그놈들 부고를 14년 기다렸는데 안 쓰겠소?'),
          say('song', '내가 죽였으면 좋겠소? 나도 그랬으면 좋겠소. 그런데 나는 차단기가 뭔지 승강기가 어떻게 서는지도 모르오. 평생 버스 운전만 했소.'),
        ],
      },
      {
        id: 'days',
        label: '사고가 난 날들',
        when: { clue: 'posts' },
        lines: [
          say('song', '그날들에 어디 있었느냐고? 화요일이랑 목요일은 법원 앞이오. 14년째. 2월 18일은… 집사람 생일이라 일요일인데도 나갔지.'),
          say('song', '증명? 경찰이 나를 맨날 찍어 가오. 댁네 서류철에 내 얼굴이 수백 장은 있을 거요.'),
        ],
      },
      {
        id: 'yoon',
        label: '윤태준 부부',
        when: { clue: 'nineNames' },
        lines: [
          say('song', '윤 선생 내외? 좋은 사람들이었지. 남편은 낮에는 고등학교에서 화학을 가르치고, 밤에는 애들 학비 번다고 내외가 같이 야간 분류를 뛰었소.'),
          say('song', '아들이 둘이었는데. 큰애는 장례 내내 한마디도 안 하고 서류만 들여다봤고, 작은애는 재판 날마다 맨 앞줄에 앉아서 피고인들 얼굴만 봤지.'),
          say('song', '작은애는 선고 나던 날 이후로 유족회에 발을 끊었소. 큰애는 지금도 기일이면 꽃을 보내고.'),
        ],
        gives: ['twoSons'],
      },
    ],
    present: {
      judgment: {
        lines: [
          say('song', '그 종이를 나한테 보여 주는 거요? 나는 그걸 외우고 있소. 변재만 징역 3년에 집행유예 5년. 나머지는 벌금이랑 집행유예.'),
        ],
      },
      alibi: {
        lines: [
          say('song', '거 보시오. 14년 동안 날 범죄자처럼 찍어 대더니, 그게 쓸모가 있네.'),
        ],
      },
    },
    fallback: [say('song', '그런 건 나는 모르오.')],
  },
  {
    id: 'byun',
    name: '변재만',
    age: 71,
    role: '한성그룹 회장',
    tag: '용의자',
    loc: 'hansung',
    desc: '14년 전 한성물류의 대표. 징역 3년에 집행유예 5년을 받았다. 유족들이 뇌물과 위증이라는 새 혐의로 그를 고발했고, 수사대는 그가 옛 공범들의 입을 막았을 가능성을 본다.',
    topics: [
      {
        id: 'fire',
        label: '14년 전 화재',
        lines: [
          say('byun', '그 일은 법원이 끝낸 일이오. 나는 판결을 받았고 유예 기간을 다 채웠소. 법적으로 깨끗한 사람이오.'),
        ],
      },
      {
        id: 'dead',
        label: '죽은 세 사람',
        lines: [
          say('byun', '옛날 직원과 거래처 사람들이오. 안됐지만 나와는 상관없는 사고들이지. 10년 넘게 본 적도 없소.'),
          say('byun', '수사대에서는 내가 입막음을 했다고 본다지? 형사 양반, 나는 그 사람들 입이 무섭지 않소. 그 사람들도 나만큼 잃을 게 많았으니까.'),
        ],
      },
      {
        id: 'safety',
        label: '안전장치',
        lines: [
          say('byun', '우리 그룹은 작년에 안전경영 대상을 받았소. 로비에서 봤을 거요.'),
          say('byun', '스프링클러? 그때는 다들 그렇게 했소. 물건이 젖으면 손해가 얼만데. 지금 기준으로 그때를 재단하면 안 되지.'),
        ],
      },
    ],
    present: {
      judgment: {
        lines: [
          say('byun', '집행유예는 사실상 무죄요. 나는 하루도 살지 않았소.'),
        ],
      },
      note1: {
        lines: [
          say('byun', '점검 기사가 끄적인 메모를 회장이 봐야 하오? 그런 건 밑에서 알아서 하는 거요.'),
        ],
      },
    },
    fallback: [say('byun', '10분 다 됐소.')],
  },
];

// Notebook entries that only appear once the player has learned of them.
export const EXTRAS = [
  {
    when: { clue: 'files' },
    name: '표영달',
    age: 58,
    role: '소방 점검업체 대표',
    tag: '피해자',
    desc: '2024년 7월 화성의 자기 회사 창고에서 화물용 승강기 통로로 추락사. 남의 건물 소방 점검을 해 주는 업체의 대표였다.',
  },
  {
    when: { clue: 'files' },
    name: '최동환',
    age: 61,
    role: '창고업',
    tag: '피해자',
    desc: '2024년 11월 부산의 개인 창고 화재로 사망. 창고를 빌려주는 일을 했다. 전기 히터의 과열 방지 장치가 듣지 않았다.',
  },
  {
    when: { clue: 'judgment' },
    name: '다섯 피고인',
    role: '2012년 선고, 한성물류센터 화재',
    tag: '기록',
    desc: '한성물류 대표 변재만. 현장 이사 최동환(도난을 막는다며 비상구에 자물쇠를 채웠다). 안전관리자 남기찬. 점검업체 대표 표영달(그 건물에 「양호」 판정을 내렸다). 관할 소방서 점검 담당 구상철. 다섯 모두 집행유예나 벌금으로 풀려났다.',
  },
  {
    when: { clue: 'witness' },
    name: '점검 기사',
    role: '이름도 나이도 모름',
    tag: '증인?',
    desc: '현장마다 손글씨 경고를 남긴 사람. 젊고, 말수가 적고, 손이 빠르다. 모자와 마스크 때문에 얼굴을 기억하는 사람이 없다.',
  },
  {
    when: { clue: 'fourthNote' },
    name: '남기찬',
    age: 55,
    role: '음성 식품공장 공장장',
    tag: '다음 표적',
    desc: '14년 전 한성물류의 안전관리자. 지금 일하는 공장에서 탱크의 산소 경보를 끄게 했다. 지난주, 그 공장 점검표에 같은 글씨의 메모가 남았다.',
  },
];

// Each plays once, on a move, in this order, once the player holds that many clues.
// The first five are the two of them: three memories, the first Saturday she cannot keep, the dinner he brings.
// The shortest route to the deduction is nine clues over five moves with 2, 3, 4, 5 and 6 clues in hand
// (or six moves starting from none), so 1, 2, 4, 5, 6 are the highest thresholds every player still passes.
// 'trip' and 'dinner' can fall before or after the heater scene; neither says anything that depends on it.
export const EVENTS = [
  {
    id: 'snow',
    cluesAtLeast: 1,
    lines: [
      n('출장 가방 앞주머니에 손을 넣었다가 딱딱한 것이 잡혔다. 다 쓰고 굳은 핫팩이다. 1월부터 거기 들어 있었다.'),
      n('새해 들어 처음 눈이 온 날이었다. 변사 사건 하나로 서른 시간을 서에 있다가 새벽 한 시에 나왔는데, 정문 앞에 윤은호가 서 있었다. 머리와 어깨에 눈이 쌓여 있었다.'),
      say('eunho', '끝나면 연락 준다고 하셨는데 연락이 없어서요. 그냥 와 봤습니다.'),
      n('윤은호는 주머니에서 핫팩을 꺼내 내 손에 쥐여 줬다. 그 시간에 문을 연 데는 국밥집 하나뿐이었다.'),
      say('eunho', '뚝배기가 왜 오래 뜨거운지 아세요. 흙으로 구운 그릇은 두껍고, 열을 천천히 내놓습니다. 그래서 불에서 내려도 한참을 혼자 끓어요. 스테인리스 냄비였으면 벌써…'),
      n('설명은 내 국밥이 반쯤 빌 때까지 이어졌다. 윤은호의 숟가락은 그때까지 그대로 놓여 있었다.'),
      say('eunho', '…죄송합니다. 제가 말이 너무 많았죠. 피곤하실 텐데.'),
      me('아니에요. 계속해요.'),
      n('형사에게는 다들 짧게 말한다. 나한테 뭔가를 그렇게 길게 설명해 준 사람은 오랜만이었다. 나는 그날 뚝배기 얘기를 끝까지 들었다.'),
    ],
  },
  {
    id: 'home',
    // Always plays before the heater scene can be reached. No 39, 92 or 7 here, and no word of the label.
    cluesAtLeast: 2,
    lines: [
      say('kwak', '서 경위 만나는 사람이 국과수에 있다며. 대장한테 들었어. 그 국과수 양반은 식구가 어떻게 돼?'),
      me('동생이 하나 있어요.'),
      n('2월에 윤은호의 집에 처음 갔다. 냉장고 문에 누렇게 바랜 쪽지 두 장이 자석으로 붙어 있었다. 위의 것에는 「11 · 31」, 아래 것에는 「28 · 31 · 31」이라고 적혀 있었다.'),
      say('eunho', '아버지가 저희 형제한테 원자 번호로 글 쓰는 걸 가르치셨어요. 11번은 나트륨, Na. 31번은 갈륨, Ga. 동생이 어릴 때 자기 방문에 붙여 놓은 겁니다. 나가.'),
      say('eunho', '밑에 건 제가 써 붙인 답장이고요. 28번이 니켈, Ni입니다. 니가 가.'),
      n('윤은호는 그 얘기를 하면서 웃었다. 웃다가 말이 없어졌다.'),
      n('부모님을 불로 잃은 이듬해에 윤은호는 서울로 대학을 갔다. 중학교 3학년이던 동생은 서해의 삼촌 집에 남았다.'),
      say('eunho', '전화는 매달 겁니다. 받는 건 일 년에 한 번쯤이에요.'),
      n('작은방에는 침대가 하나 있었고, 이불이 반듯하게 개어져 있었다.'),
      say('eunho', '동생 방입니다. 언제든 오라고요. 아직 온 적은 없어요.'),
      n('나는 그날 그 집에서 저녁을 먹고 왔다. 곽 경사에게는 거기까지 얘기하지 않았다.'),
    ],
  },
  {
    id: 'transfer',
    cluesAtLeast: 4,
    lines: [
      say('kwak', '서 경위는 여기 왜 왔어. 광수대는 주말도 없고 집에도 못 가는데.'),
      me('오고 싶었어요.'),
      n('3월에 발령이 난 날 저녁, 윤은호에게도 그렇게 말했다. 윤은호는 내 휴대폰으로 공문을 끝까지 읽고는 나보다 더 좋아했다.'),
      say('eunho', '잘됐어요. 지안 씨가 가고 싶어 하던 데잖아요. 정말 잘됐습니다.'),
      me('거기는 주말이 따로 없대요. 출장도 많고요. 토요일에 못 오는 날이 생길 거예요.'),
      say('eunho', '토요일은 제가 맞출게요.'),
      say('eunho', '지안 씨가 못 오면 제가 그쪽으로 가면 됩니다. 꼭 과학관이 아니어도 되고요.'),
      n('나는 그 말을 듣고 나서야 발령이 기뻤다.'),
    ],
  },
  {
    id: 'trip',
    // The phone and 윤은호 refer back to it.
    cluesAtLeast: 5,
    lines: [
      n('고속도로 휴게소. 곽 경사가 호두과자 봉지를 내밀었다.'),
      say('kwak', '먹어. 서 경위는 사건 물면 밥을 안 먹더라.'),
      say('kwak', '전에 모시던 반장님이 순직하셨다며. …그 양반도 사건 물면 밥을 안 먹었어?'),
      me('믹스커피만 드셨어요.'),
      say('kwak', '그럼 서 경위는 호두과자라도 먹어.'),
      say('kwak', '아, 그리고 이번 토요일 당직은 서 경위야. 새로 온 사람이 첫 주에 서는 게 여기 순서라서.'),
      n('토요일. 나는 호두과자 봉지를 내려놓고 휴대폰을 꺼냈다.'),
      n('나: 「이번 토요일에 당직이 걸렸어요. 과학관은 못 갈 것 같아요. 미안해요.」'),
      n('윤은호: 「괜찮아요. 당직이면 어쩔 수 없죠. 다음 주에 가요.」'),
      n('올게요, 하고 대답한 지 며칠 되지 않았다. 간다고 해 놓고 못 가는 것은 이번이 처음이다.'),
    ],
  },
  {
    id: 'dinner',
    cluesAtLeast: 6,
    lines: [
      n('그날 밤, 수사대 회의실. 문 대장의 사건 회의는 아홉 시에 시작해서 자정을 넘겼다. 새로 온 사람이 중간에 일어설 수 있는 자리가 아니다.'),
      n('열 시쯤 곽 경사가 전화를 받고 나갔다가 들어왔다. 나를 한 번 보고는 그냥 앉았다.'),
      n('새벽 두 시에 자리로 돌아오니 책상에 보자기로 싼 도시락이 놓여 있었다. 뚜껑에 메모지가 한 장 붙어 있었다. 「드시고 하세요.」 윤은호의 글씨다. 다른 말은 없었다.'),
      n('밥은 식어 있었다. 나는 책상에 앉아 그것을 다 먹었다.'),
      n('아침에 곽 경사가 말했다.'),
      say('kwak', '어젯밤에 그 국과수 양반 왔다 갔어. 회의 중이라 못 나온다고 했더니 복도에서 사십 분을 서 있더라. 내가 전해 준다고 하니까 그제야 갔어.'),
      n('고맙다는 메시지는 그 얘기를 듣고 나서야 보냈다.'),
    ],
  },
  {
    id: 'summons',
    cluesAtLeast: 16,
    lines: [
      n('문 대장에게서 전화가 왔다.'),
      say('moon', '서 경위. 위에서 유족회 대표 송영만부터 부르라고 난리야. 출석 요구서 나갔다. 다음 주 월요일이야. 위는 쉬운 그림을 좋아해. 다른 그림이 있으면 그 전에 가져와.'),
      n('위에서 고르기 쉬운 사람은 송영만이다. 14년을 법원 앞에서 피켓을 들고 서 있던 사람이다.'),
    ],
  },
];

export const DEDUCTION = {
  // Checked in order; the first missing clue decides which hint the player hears.
  required: [
    { clue: 'files', hint: '아직 세 건의 기록도 제대로 읽지 않았다. 내 책상의 서류부터다.' },
    { clue: 'bypass1', hint: '홍천 별장의 누전차단기를 직접 봐야 한다.' },
    { clue: 'pump', hint: '홍천의 욕조. 전기가 어디서 샜는지 아직 보지 않았다.' },
    { clue: 'note1', hint: '홍천 별장에 점검 기록이 남아 있을 것이다.' },
    { clue: 'pumpCut', hint: '떼어 온 펌프를 국과수에 맡겼다. 결과를 들으러 가야 한다.' },
    { clue: 'bypass2', hint: '화성 창고의 승강기 문을 직접 봐야 한다.' },
    { clue: 'bulb', hint: '화성의 승강장은 왜 어두웠나. 전등을 봐야 한다.' },
    { clue: 'textMsg', hint: '표영달은 왜 저녁에 혼자 2층에 올라갔나. 화성 창고에서 사건 기록의 통화 내역을 봐야 한다.' },
    { clue: 'note2', hint: '화성 창고에도 점검 기록이 있을 것이다.' },
    { clue: 'witness', hint: '화성 창고 직원이 그 점검 기사를 기억할지 모른다.' },
    { clue: 'noPart', hint: '전선에 붙은 숫자. 무슨 번호인지 수사대에서 조회해 봐야 한다.' },
    { clue: 'daesung', hint: '홍천의 메모 글씨를 어디서 본 것 같다. 수사대에 있는 내 옛 사건 기록을 꺼내 봐야 한다.' },
    { clue: 'judgment', hint: '죽은 세 사람 사이에 뭔가 있다. 이름을 검색해 봐야 한다.' },
    { clue: 'busanReport', hint: '세 번째 사고, 부산 화재의 조사 보고서는 국과수에 있다.' },
    { clue: 'bypass3', hint: '부산의 히터에도 같은 전선이 있었는지. 윤은호와 함께 다시 봐야 한다.' },
    { clue: 'posts', hint: '수사대가 의심하는 유족회 대표. 그 근거를 직접 봐야 한다.' },
    { clue: 'alibi', hint: '송영만이 그날들에 어디 있었는지 확인해야 한다. 수사대에서 알아볼 수 있다.' },
    { clue: 'nineNames', hint: '유족회 사무실 벽의 사진들을 아직 제대로 보지 않았다.' },
    { clue: 'knew', hint: '윤은호에게 물어야 할 것이 있다. 부산에서 죽은 사람이 누구인지 알았느냐고.' },
    { clue: 'handwriting', hint: '세 현장의 메모가 같은 글씨인지. 국과수에서 대조해 봐야 한다.' },
    { clue: 'rescueRule', hint: '윤은호가 요즘 맡은 사건 얘기를 아직 듣지 않았다.' },
    { clue: 'fourthNote', hint: '다섯 중 둘이 남았다. 그 두 사람의 사업장에 전화를 걸어 봐야 한다.' },
  ],
  opening: [
    n('4월 11일 금요일 오후. 문 대장의 방.'),
    n('책상 위에 송영만의 출석 요구서 사본과 변재만 회장에 대한 내사 보고서가 나란히 놓여 있다. 수사대가 가진 두 장의 패다.'),
    say('moon', '유족 아니면 회장. 둘 중 하나를 가져오라고 했지. 어느 쪽이야.'),
    me('둘 다 아닙니다. 그 전에, 이 세 건이 사고가 아니라는 것부터 보여 드리겠습니다.'),
  ],
  wrong: [
    n('…아니다. 이것으로는 문 대장을 움직일 수 없다.'),
    say('moon', '서 경위. 내 시간은 비싸.'),
  ],
  steps: [
    {
      type: 'evidence',
      label: '홍천의 감전이 사고가 아니라는 증거를 제시하라',
      prompt: [say('moon', '홍천부터. 낡은 차단기가 고장 난 사고잖아.')],
      accept: ['pumpCut'],
      near: {
        bypass1: [n("차단기를 건너뛴 전선은 죽은 사람이 시켜서 단 것이다. 그것만으로는 '본인 잘못'이다. 전기가 새게 만든 손을 보여 줘야 한다.")],
        pump: [n('벗겨진 피복은 봤다. 그것이 닳은 것이 아니라는 분석 결과가 필요하다.')],
      },
      success: [
        me('차단기는 고장 난 게 아니라 건너뛰어져 있었습니다. 구상철 본인이 시킨 일입니다. 여기까지는 사고처럼 보입니다.'),
        me('하지만 욕조 펌프의 전선 피복은 닳은 게 아니라 칼로 벗겨져 있었습니다. 접지선은 드라이버로 풀려 있었고요. 국과수 분석입니다.'),
        me('차단기가 죽어 있다는 것을 아는 누군가가, 전기가 물로 새도록 만들었습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '화성의 추락이 사고가 아니라는 증거를 제시하라',
      prompt: [say('moon', '화성은.')],
      accept: ['bulb', 'textMsg'],
      near: {
        bypass2: [n("잠금장치를 건너뛴 전선은 죽은 사람이 시켜서 단 것이다. 그것만으로는 '본인 잘못'이다. 표영달을 그 문 앞에 세운 손을 보여 줘야 한다.")],
      },
      success: [
        me('승강장 전등은 수명이 다한 게 아니라 반 바퀴 풀려 있었습니다. 전날 갈아 끼운 새 전구였습니다.'),
        me('그리고 표영달은 닷새짜리 선불폰에서 온 문자를 받고 혼자 2층으로 올라갔습니다. 승강기에 실어 둔 상자를 세어 달라는 문자였습니다. 그날 칸은 2층에 없었습니다.'),
        me('문 잠금장치가 죽어 있다는 것을 아는 누군가가, 불을 끄고, 칸이 와 있다고 믿게 해서 표영달이 그 문을 열게 했습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '세 사건이 한 사람의 손이라는 증거를 제시하라',
      prompt: [say('moon', '두 건이 수상하다 치자. 강원도랑 경기도야. 부산까지 셋을 한 줄로 묶을 근거가 있어?')],
      accept: ['bypass3', 'bypass1', 'bypass2', 'handwriting', 'noPart'],
      near: {
        note1: [n('메모 한 장으로는 부족하다. 세 장이 같은 글씨라는 결과, 또는 세 현장에 똑같이 남은 물건이 필요하다.')],
        note2: [n('메모 한 장으로는 부족하다. 세 장이 같은 글씨라는 결과, 또는 세 현장에 똑같이 남은 물건이 필요하다.')],
        busanReport: [n('보고서에는 메모가 있었다고만 적혀 있고, 결론은 여전히 사고다. 세 장이 같은 글씨라는 결과, 또는 세 현장에 똑같이 남은 물건이 필요하다.')],
      },
      success: [
        me('세 현장에서 안전장치를 건너뛴 전선마다 같은 라벨이 붙어 있습니다. 39-92-7. 어느 제조사에도 없는 번호입니다.'),
        me('세 현장의 점검표에는 같은 글씨의 메모가 있습니다. 「복구 요망. 관리자 서명 거부.」 필적 대조 결과 같은 사람입니다.'),
        me('부산도 사고가 아닙니다. 히터의 온도 조절 손잡이가 최고 단에서 접착제로 굳혀져 있었습니다. 국과수가 보고서 정정을 올렸습니다.'),
        me('한 사람이 세 곳에서 안전장치를 건너뛰는 전선을 달았고, 세 곳에 경고를 남겼습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '죽은 세 사람의 연결을 제시하라',
      prompt: [say('moon', '그럼 왜 그 셋이야.')],
      accept: ['judgment'],
      near: {
        nineNames: [n('벽의 아홉 이름은 그날 죽은 사람들이다. 지금 필요한 것은 그 일로 재판받은 다섯 이름이다.')],
      },
      success: [
        me('2010년 한성물류센터 화재. 아홉 명이 숨졌고 다섯 명이 재판을 받았습니다. 세 사람은 그 다섯 중 셋입니다.'),
        me('그때도 스프링클러는 잠겨 있었고 경보는 꺼져 있었습니다. 세 사람은 14년 뒤에도 자기 건물의 안전장치를 끄게 했습니다. 그리고 그 꺼진 장치 옆에서 죽었습니다.'),
      ],
    },
    {
      type: 'evidence',
      label: '송영만이 범인이 아니라는 증거를 제시하라',
      prompt: [say('moon', "그럼 유족이네. 송영만. 죽을 때마다 '하나 갔다'고 쓴 사람이야.")],
      accept: ['alibi'],
      near: {
        posts: [n('그 글은 문 대장이 든 근거다. 그날 송영만이 어디 있었는지를 보여 줘야 한다.')],
      },
      success: [
        me('세 사람이 죽은 날, 송영만은 서울 법원 앞에서 피켓을 들고 있었습니다. 우리 쪽 채증 사진에 세 번 다 찍혀 있습니다.'),
        say('moon', '미리 손을 써 놓고 갔다며. 그럼 죽은 날 어디 있었는지가 무슨 소용이야.'),
        me('그래서 사진만으로는 부족합니다. 그 손을 보십시오. 피복을 칼로 벗기고, 접지 나사를 풀고, 전구를 반 바퀴만 풀어 둔 손입니다. 평생 버스를 몬 예순일곱의 손이 아닙니다.'),
        me('그리고 현장에 드나든 사람은 따로 있습니다. 젊은 점검 기사 한 사람입니다.'),
        say('moon', '…그럼 변재만의 입막음이군. 그 기사는 돈 받고 선을 달아 준 거고.'),
      ],
    },
    {
      type: 'evidence',
      label: '경고를 남긴 기사가 증인이 아니라 범인이라는 근거를 제시하라',
      prompt: [
        me('그것도 아닙니다. 입막음이라면 경고 메모를 남길 이유가 없습니다. 저는 그 메모를 쓴 기사를 범인으로 봅니다.'),
        say('moon', '그 기사는 위험하다고 적어 놓고 간 사람이잖아. 말린 사람이 왜 범인이야.'),
      ],
      accept: ['witness'],
      near: {
        note1: [n('메모는 그 기사가 말렸다는 증거다. 문 대장이 든 근거와 같다. 그 기사가 무엇을 알고 왔는지를 보여 줘야 한다.')],
        note2: [n('메모는 그 기사가 말렸다는 증거다. 문 대장이 든 근거와 같다. 그 기사가 무엇을 알고 왔는지를 보여 줘야 한다.')],
        handwriting: [n('같은 사람이 세 곳에 다녀갔다는 것은 이미 보여 줬다. 그 기사가 무엇을 알고 왔는지를 보여 줘야 한다.')],
        noName: [n('이름을 남기지 않았다는 것은 수상할 뿐이다. 그 기사가 무엇을 알고 왔는지를 보여 줘야 한다.')],
      },
      success: [
        me('화성 창고 직원의 증언입니다. 기사는 나가면서 표영달에게 물었습니다. 「예전에도 이렇게 꺼 두셨습니까.」 표영달의 얼굴이 하얘졌다고 합니다.'),
        me('그 기사는 이 사람들이 14년 전에 무엇을 껐는지 알고 왔습니다. 그리고 세 곳 모두에서 안전장치가 꺼져 있다는 것을 아는 사람은, 그 전선을 단 기사 하나뿐입니다.'),
        me('그 기사는 매번 먼저 물었습니다. 끌 거냐고. 서명하겠느냐고. 그리고 끄겠다는 사람만 죽였습니다.'),
        say('moon', '…말린 게 아니라 시험을 했다는 거네.'),
      ],
    },
    {
      type: 'choice',
      label: '다음 표적은 누구인가',
      prompt: [
        say('moon', '이름도 얼굴도 없는 용의자야. 아직은 가설이고. 좋아, 그럼 하나만 대 봐. 네 말이 맞다면 다음은 누구야.'),
      ],
      options: [
        { id: 'byun', label: '변재만 회장' },
        { id: 'song', label: '송영만' },
        { id: 'nam', label: '남기찬 공장장' },
        { id: 'none', label: '더는 없다' },
      ],
      accept: ['nam'],
      rebuttal: {
        byun: [say('moon', '회장은 경호원 넷을 달고 다녀. 본사 방재실에도 그런 메모는 없다며.')],
        song: [say('moon', '방금 네 입으로 아니라고 한 사람이야. 표적이라는 근거는 더 없고.')],
        none: [say('moon', '다섯 중 셋이 죽었는데 더는 없다고? 근거가 뭐야.')],
      },
      success: [
        me('남기찬입니다. 당시 안전관리자였고 지금은 음성의 식품공장 공장장입니다. 지난주 화요일, 그 공장 점검표에 같은 글씨의 메모가 남았습니다.'),
        me('「산소 경보 차단 요청받음. 탱크 출입 시 질식 위험. 복구 요망. 관리자 서명 거부.」'),
        n('문 대장은 한참 메모 사본을 내려다봤다. 그리고 전화기를 들었다.'),
        say('moon', '음성 공장에 전화 넣어. 공장장 바꾸라고 해.'),
        n('출장에서 막 돌아왔다는 남기찬이 전화를 받았다. 스피커폰 너머로 목소리가 들렸다.'),
        me('광역수사대 서지안입니다. 탱크의 산소 경보를 지금 다시 켜셔야 합니다.'),
        say('nam', '경보를 다시 켜라고요? 형사님, 그거 켜면 하루에 세 번씩 라인이 섭니다. 내가 안전관리를 20년 했어요. 뭐가 위험한지는 내가 압니다.'),
        me('같이 재판받은 세 분이 죽었습니다. 세 분 다 꺼 둔 안전장치 옆에서요. 오늘은 탱크에 들어가지 마세요.'),
        say('nam', '사고로 죽은 사람들 얘기를 왜 나한테 합니까. 오늘 저녁이 탱크 월례 점검입니다. 바쁩니다. 끊습니다.'),
        n('전화가 끊겼다. 다시 걸었지만 받지 않았다. 문 대장이 나를 봤다.'),
        say('moon', '가. 수사본부는 내가 올린다. 음성서에 순찰차 보내라고 할 테니까, 밟아.'),
      ],
    },
    // The rescue: one wrong move here ends it.
    {
      type: 'choice',
      stage: '구조',
      sudden: 'fallen',
      label: '어떻게 할 것인가',
      brief: '남기찬이 탱크 바닥에 쓰러져 있다. 탱크 안은 조용하고 냄새가 없다. 사다리는 맨홀에 걸려 있다.',
      prompt: [
        n('음성까지 한 시간 사십 분. 곽 경사는 그 길을 한 시간 십 분에 달렸다. 저녁 일곱 시 오 분, 공장 정문.'),
        n('정문을 들어서는 우리 차와, 나가는 흰색 승합차가 엇갈렸다. 옆구리에 점검 업체 이름이 붙은 차다.'),
        n('운전석의 남자와 눈이 마주쳤다. 모자, 마스크. 그 남자는 서두르지도 피하지도 않았다. 나를 보고 가볍게 목례를 했다.'),
        n('어디서 본 눈이다. 그 생각을 붙잡기도 전에 곽 경사가 소리쳤다.'),
        say('kwak', '서 경위! 저기, 탱크!'),
        n('공장 뒤편, 2층 건물 높이의 식용유 저장 탱크. 꼭대기 맨홀이 열려 있고 사다리가 안으로 걸려 있다. 탱크 옆 배전반 문은 열린 채 바람에 흔들리고 있었다.'),
        n('맨홀로 손전등을 비췄다. 5미터 아래 바닥에 작업복 차림의 남자가 모로 누워 있다. 남기찬이다. 움직이지 않는다.'),
        n('탱크 안은 조용했다. 냄새도 없다. 사다리가 바로 발밑에 있다.'),
      ],
      options: [
        { id: 'down', label: '사다리를 타고 바로 내려간다' },
        { id: 'breath', label: '숨을 크게 들이마시고, 참은 채 내려간다' },
        { id: 'stay', label: '내려가지 않는다. 밖에서 할 일을 찾는다' },
      ],
      accept: ['stay'],
      rebuttal: {
        down: [
          n('나는 사다리에 발을 올렸다. 세 칸을 내려갔을 때 눈앞이 하얗게 번졌다. 숨이 찬 느낌조차 없었다.'),
          n('윤은호가 말했었다. 열에 둘은 구하러 들어간 사람이라고.'),
        ],
        breath: [
          n('숨을 참고 내려갔다. 바닥에 닿아 남기찬의 몸을 잡아당기는 순간, 참았던 숨이 저절로 터졌다. 한 번을 들이마셨다.'),
          n('한두 번이면 정신을 잃는다고, 윤은호는 분명히 말했었다.'),
        ],
      },
      success: [
        n('발이 사다리로 가려는 것을 붙잡았다. 윤은호의 목소리가 떠올랐다. 들어가지 말 것.'),
        me('곽 경사님, 내려가면 안 돼요! 저 안에는 숨 쉴 공기가 없어요. 내려간 사람도 같이 쓰러져요. 119부터 불러요. 탱크 안 질식이라고요.'),
        say('kwak', '불렀어! 십오 분 걸린대. 그동안 어쩌자고, 사람이 저기 누워 있는데!'),
      ],
    },
    {
      type: 'choice',
      stage: '구조',
      sudden: 'fallen',
      label: '무엇부터 할 것인가',
      brief: '탱크 옆에 질소 공급 밸브와 배전반이 있다. 배전반의 환기팬 차단기는 내려가 있다.',
      prompt: [
        n('탱크 옆 굵은 배관에서 쉬익 소리가 난다. 배관에는 「질소」라고 적혀 있다.'),
        n('배전반을 봤다. 「탱크 환기팬」이라고 적힌 차단기 하나만 내려가 있다. 나머지는 전부 올라가 있다.'),
        n('벽에는 용접용 산소통 두 개가 쇠사슬에 묶여 있다.'),
      ],
      options: [
        { id: 'oxygen', label: '용접용 산소통의 호스를 탱크 안에 넣고 튼다' },
        { id: 'valve', label: '질소 밸브를 잠그고 환기팬 차단기를 올린다' },
        { id: 'wait', label: '아무것도 손대지 않고 119를 기다린다' },
      ],
      accept: ['valve'],
      rebuttal: {
        oxygen: [
          n('산소통 밸브를 열어 호스를 맨홀에 밀어 넣었다. 순수한 산소가 기름 찌꺼기 묻은 탱크 안으로 쏟아졌다.'),
          n('곽 경사의 손전등이 맨홀 테두리에 부딪혀 불꽃이 튀었다. 기름과 순수한 산소 사이에서.'),
        ],
        wait: [
          n('우리는 맨홀 옆에서 기다렸다. 일 분, 이 분. 질소는 계속 들어갔다. 곽 경사가 먼저 참지 못했다.'),
          say('kwak', '못 봐. 사람이 죽어 가는데 서서는 못 봐.'),
          n('곽 경사가 사다리로 내려갔다. 붙잡을 틈이 없었다. 곽 경사의 손이 사다리에서 풀리는 것을 보고, 나도 따라 내려갔다.'),
        ],
      },
      success: [
        n('질소 배관의 붉은 밸브를 두 손으로 돌려 잠갔다. 쉬익 소리가 멎었다.'),
        n('배전반의 차단기를 올리자 탱크 꼭대기의 환기팬이 굉음을 내며 돌기 시작했다. 바깥 공기가 탱크 안으로 밀려 들어갔다.'),
        say('kwak', '됐어? 이제 내려가도 돼?'),
        me('아직요. 바람이 들어가도 바닥까지 바뀌려면 한참 걸려요.'),
      ],
    },
    {
      type: 'choice',
      stage: '구조',
      sudden: 'fallen',
      label: '어떻게 끌어올릴 것인가',
      brief: '환기팬이 돌기 시작했다. 탱크 옆 비상함에는 방진 마스크, 공기통이 달린 공기호흡기, 구명줄 두 타래가 들어 있다.',
      prompt: [],
      options: [
        { id: 'mask', label: '방진 마스크를 쓰고 내려간다' },
        { id: 'kwakGo', label: '힘이 좋은 곽 경사를 먼저 내려보낸다' },
        { id: 'scba', label: '공기호흡기를 메고 구명줄을 묶은 뒤, 곽 경사에게 줄을 맡기고 내려간다' },
      ],
      accept: ['scba'],
      rebuttal: {
        mask: [
          n('방진 마스크 끈을 조이고 내려갔다. 마스크 안으로 들어온 것은 걸러진 질소였다.'),
          n('마스크는 먼지를 거를 뿐, 없는 산소를 만들어 주지는 못한다고 윤은호가 말했었다.'),
        ],
        kwakGo: [
          n('곽 경사가 사다리를 잡았다. 맨몸으로. 나는 말리지 않았다.'),
          n('다섯 칸을 내려간 곽 경사의 손이 풀렸다. 나는 생각할 틈도 없이 따라 내려갔다.'),
        ],
      },
      success: [
        n('공기호흡기를 멨다. 얼굴을 덮는 마스크를 쓰자 내 숨소리만 크게 들렸다. 구명줄 하나는 내 허리에 묶고, 하나는 어깨에 걸었다. 두 줄의 끝을 곽 경사에게 넘겼다.'),
        me('제가 줄을 두 번 당기면 어깨에 걸고 간 줄부터 끌어올려요. 남기찬 씨가 묶여 있을 거예요. 신호가 없어도 3분이 지나면 제 줄을 무조건 끌어올리고요.'),
        say('kwak', '…알았어. 3분이야. 1초도 더 안 줘.'),
      ],
    },
  ],
};

export const ENDINGS = {
  true: {
    title: '확산',
    lines: [
      n('탱크 바닥은 미끄러웠다. 어깨에 걸고 간 줄을 남기찬의 겨드랑이 밑으로 감아 묶고 두 번 당겼다. 곽 경사가 맨홀 난간에 줄을 걸고 온몸으로 끌어올렸다.'),
      n('맨홀 밖 철판 위에 남기찬을 눕혔을 때 구급차 사이렌이 들리기 시작했다. 나는 가슴을 눌렀다. 구급대원이 내 어깨를 잡을 때까지 눌렀다.'),
      n('저녁 7시 52분, 남기찬은 사망 판정을 받았다.'),
      say('kwak', '…서 경위 잘못 아니야. 저 양반은 우리가 정문 들어설 때 벌써 저 밑에 있었어.'),
      n('탱크의 기록계가 곽 경사의 말을 확인해 줬다. 질소 밸브가 열린 것은 6시 20분. 환기팬 차단기가 내려간 것도 그때다. 남기찬이 월례 점검을 하러 내려간 것은 6시 25분.'),
      n('우리는 40분 늦었다. 전화를 끊은 남기찬이 탱크로 걸어가고 있을 때, 우리는 아직 고속도로 위에 있었다.'),
      n('음성서 순찰차는 6시 30분에 정문까지 왔다가 돌아갔다. 경비는 공장장이 탱크 점검 중이라 만날 수 없다고 했고, 순찰차에는 문을 밀고 들어갈 근거가 없었다. 그때까지 이 일은 종결된 사고 세 건과 메모 한 장이었다.'),
      n('산소 경보기의 신호선은 짧은 전선으로 건너뛰어져 있었다. 흰 라벨에 숫자 세 개. 39-92-7.'),
      n('공장 CCTV에는 6시 18분, 탱크 옆 배전반 앞에 선 남자의 뒷모습이 남아 있었다. 점검 업체 조끼, 모자. 얼굴은 한 번도 카메라를 향하지 않았다.'),
      n('정문에서 엇갈린 흰색 승합차의 번호판은 도난 신고된 것이었다. 그날 그 남자와 눈을 맞춘 사람은 나 하나다. 그리고 나는 눈밖에 보지 못했다.'),
      n('그 남자는 나를 보고 목례를 했다. 내가 누구인지, 왜 왔는지 아는 사람처럼.'),
      n('다음 날은 토요일이었다. 나는 당직실이 아니라 음성 공장에서 하루를 보냈다. 저녁 여덟 시쯤 시계를 한 번 봤다. 과학관 옥상에 줄이 서 있을 시간이었다.'),
      n('다음 주 월요일, 광역수사대에 「한성물류 화재 연쇄 사건 수사본부」가 세워졌다. 사고 세 건은 살인 사건으로 바뀌었고, 네 번째가 더해졌다.'),
      say('moon', '서 경위가 옳았어. 그런데 옳은 걸로는 아무도 못 살려. 잡아야 살려.'),
      n('석 달이 지났다. 점검 기사의 이름은 여전히 서류 어디에도 없다. 그 기사는 매번 하청의 하청으로 들어갔다. 점검표에 적힌 자격 번호의 주인들은 그 현장에 가 본 적도 없는 사람들이었다.'),
      n('다섯 명 중 남은 사람은 변재만 회장 하나다. 회장은 경호원을 여섯으로 늘렸고, 6월로 잡아 둔 창립 30주년 기념식은 가을로 미뤘다.'),
      n('내 책상 모니터에는 메모지가 한 장 붙어 있다. 39-92-7. 석 달째 그대로다.'),
      n('윤은호와는 그 뒤로 토요일을 한 번도 같이 보내지 못했다. 4월과 5월에는 내가 수사본부에서 나오지 못했다. 6월에는 내가 시간을 냈는데, 윤은호가 지방에 내려가 있다고 했다.'),
      n('윤은호의 마지막 메시지는 3주 전, 6월 말이다. 「조금만 더요. 미안해요.」 그 뒤로 내가 건 전화 네 통에는 답이 없다.'),
      n('국과수에도 두 번 찾아갔다. 한 번은 출장, 한 번은 연차라고 했다. 씻어 둔 도시락 통은 아직 내 책상 서랍에 있다.'),
      n('7월의 어느 토요일, 나는 혼자 서해과학관에 갔다.'),
      n('입구에서 회원권 카드를 내밀었다. 직원이 화면을 보고 나서 내 뒤를 한 번 봤다.'),
      say('staff', '2인 회원권이시네요. 늘 같이 오시던 분은요?'),
      me('오늘은 혼자예요.'),
      n('옥상 줄은 짧았다. 망원경 옆 안내판에 오늘 보는 별이 적혀 있었다. 「직녀성」. 목성은 여름 동안 새벽에만 뜬다고 했다.'),
      n('차례가 와서 망원경에 눈을 댔다. 푸르스름한 점 하나였다. 줄무늬도, 옆에 나란히 놓인 작은 점들도 없었다.'),
      n('초점이 조금 흐렸다. 어디를 돌려야 하는지 나는 몰랐다. 초점은 늘 윤은호가 맞춰 줬다. 나는 흐린 채로 한참 봤다.'),
      n('뒷사람에게 자리를 내주고 벤치에 앉았다. 4월에 잠들었던 그 자리다. 문 닫는다는 방송이 나올 때까지 거기 앉아 있었다.'),
    ],
    epilogue: '세 건의 사고는 연쇄살인으로 다시 열렸다. 네 번째 죽음은 막지 못했고, 범인의 이름은 아직 없다. 윤은호는 전화를 받지 않는다.',
  },
  bad: {
    title: '사고사',
    lines: [
      n('말이 꼬였다. 문 대장이 서류를 덮었다.'),
      say('moon', '여기까지 하자. 종결된 사고 세 건을 다시 열려면 이것보다는 단단해야 해.'),
      n('그날 저녁, 충북 음성의 식품공장에서 공장장이 질소가 찬 탱크에 들어갔다가 숨졌다. 나는 그 소식을 다음 날 아침에야 들었다.'),
      n('다음 주 월요일 송영만이 출석했다. 여덟 시간 조사를 받고 풀려났다. 세 건의 사고는 그대로 사고로 남았다.'),
      n('음성의 종결 보고서에는 익숙한 문장이 들어갔다. 「사고 당시 해당 안전장치는 작동하지 않는 상태였음.」'),
    ],
    epilogue: '네 번째 서류가 상자에 들어갔다. 하지만 단서는 아직 당신의 수첩에 남아 있다.',
    retry: 'deduce',
  },
  fallen: {
    title: '질식',
    lines: [
      n('그날 밤의 기억은 거기서 끊긴다.'),
      n('눈을 떴을 때는 병원이었다. 곽 경사는 옆 병실에 있다고 했다. 남기찬은 그 탱크에서 나오지 못했다.'),
      n('구하러 간 사람이 구조될 사람이 됐다. 윤은호가 말했던 그대로였다.'),
    ],
    epilogue: '들어가지 말 것. 가스를 잠그고 바람부터 넣을 것. 공기통과 구명줄. 구조 장면부터 다시 할 수 있다.',
    retry: 'confront',
  },
};
